import * as React from 'react'
function SvgDownload(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M34 26l.15.005c1.041.077 1.85.94 1.85 1.993V34c0 1.2-.8 2-2 2H6c-1.2 0-2-.8-2-2v-6.002C4 26.887 4.895 26 6 26l.15.005c1.041.077 1.85.94 1.85 1.993V32h24v-4.002c0-1.1.895-1.998 2-1.998zM20 4l.15.006c1.041.076 1.85.943 1.85 2V21.2l6.588-6.588a1.996 1.996 0 012.828.004L31.4 14.6l.101.11a2.008 2.008 0 01-.003 2.583l-.118.128L21.4 27.4c-.4.4-.8.6-1.4.6-.6 0-1-.2-1.4-.6l-9.98-9.98a2 2 0 01-.004-2.836L8.6 14.6l.11-.1a2.002 2.002 0 012.575-.005l.127.117L18 21.2V6.007C18 4.9 18.895 4 20 4z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgDownload
